module.exports = __webpack_public_path__ + "img/icon-male.4a38304e.svg";